const staticSupply = {
    business: {
        '10': '火车票',
        '20': "酒店",
        "30": '国际机票',
        "40": '保险',
        "50": '打车'
    }
}

export default staticSupply

